import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_leads-brands_page_mobile_testimonial-view';
/**
 * view the brands page mobile testimonial section
 */
export function trackBrandLeadsBrandsPageMobileTestimonialView(brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { brandToken },
    });
}
